import { useEffect } from 'react';

import { useCartState } from '@jane/monolith/components/cart/cartFacade/useCartState';
import { useCustomerSelector } from '@jane/monolith/customer/redux';
import { selectCart } from '@jane/monolith/customer/redux/cart';
import { useBrandSpecialsContext } from '@jane/shared-ecomm/providers';
import { useGetStore } from '@jane/shared/data-access';

import { CartDrawer } from './cartDrawer';
import { CartDrawerEmpty } from './cartDrawerEmpty';
import { CartDrawerError } from './cartDrawerError';
import { CartDrawerLoading } from './cartDrawerLoading';

export const CartDrawerContainer = ({
  setShowCartAlerts,
}: {
  setShowCartAlerts: (value: boolean) => void;
}) => {
  const { cart, hasLoaded } = useCartState();
  // TODO(carts-v3): the alert effect moves to the facade in R6a.
  const {
    cart: { brand_special_unavailable_reason, unavailable_products },
    isFixingUnavailableCheckout,
  } = useCustomerSelector(selectCart);

  const { showBrandSpecialAlert } = useBrandSpecialsContext();

  useEffect(() => {
    if (
      showBrandSpecialAlert ||
      !!brand_special_unavailable_reason ||
      (!isFixingUnavailableCheckout && unavailable_products.length)
    ) {
      setShowCartAlerts(true);
    }
  }, [
    isFixingUnavailableCheckout,
    brand_special_unavailable_reason,
    unavailable_products.length,
    showBrandSpecialAlert,
  ]);

  const storeId = cart?.store.id || undefined;
  const {
    data: store,
    isLoading: isLoadingStore,
    isError,
  } = useGetStore(storeId);

  const isLoading = !hasLoaded || isLoadingStore;
  const emptyCart =
    !cart?.products.length || cart.status !== 'pending' || !storeId || !store;

  if (isLoading) return <CartDrawerLoading />;
  if (isError) return <CartDrawerError />;
  if (emptyCart) return <CartDrawerEmpty />;

  return <CartDrawer />;
};
